import { createUseStyles } from 'react-jss'
import { GRAY_80 } from '@omnilert/components'

export default createUseStyles({
  avatar: {
    height: '45px',
    objectFit: 'cover',
    width: '65px'
  },
  avatarContainer: {
    alignItems: 'center',
    display: 'flex',
    margin: '0 auto',
    width: '80%'
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  buttonTitle: {
    fontSize: '18px'
  },
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  icon: {
    '--icon__primary__fill__color': GRAY_80,
    opacity: 0.5,
    padding: 20
  },
  button: {
    margin: '18px 0 !important'
  },
  message: {
    alignItems: 'center',
    backgroundColor: GRAY_80,
    borderBottomRightRadius: '3px',
    borderTopRightRadius: '3px',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    padding: '0 35px',
    width: '100%'
  },
  responsive: {
    alignItems: 'center',
    backgroundColor: 'var(--secondary__page__background__color)',
    display: 'flex',
    flexDirection: 'column',
    height: '100% !important',
    padding: '0 20px',
    width: '100% !important',
    overflowY: 'auto'
  }
})

